/**
 * Helper utilities for ChatInterface
 */

/**
 * Get current user ID from Amplify Auth (with cleaned username)
 */
export const getCurrentUserId = async (): Promise<string> => {
    try {
        const { Auth } = await import('aws-amplify');
        const user = await Auth.currentAuthenticatedUser();
        let username = user.username || 'unknown';
        
        // Remove AmazonFederate_ prefix if present
        if (username.startsWith('AmazonFederate_')) {
            username = username.substring(15);
        }
        
        return username;
    } catch (error) {
        console.error('Failed to get user ID:', error);
        // Fallback to session ID if auth fails
        return 'anonymous';
    }
};

/**
 * Extract S3 key from S3 URI (s3://bucket/key)
 */
export const extractS3KeyFromUri = (uri: string): string => {
    return uri.replace(/^s3:\/\/[^\/]+\//, '');
};

